import PropTypes from "prop-types";
import React, { Component } from "react";
import QuestionLibraryOverviewTable from "./QuestionLibraryOverviewTable";
import QuestionLibraryModal from "./QuestionLibraryModal";
import QuestionStructureSelectContainer from "./QuestionStructureSelectContainer";
import { ACTION_FIELD, RESULT } from "../../../../ducks/questionLibrary";
import StandardView from "../../../common/StandardView";

/**
 *Component which represents overview of question library
 */
class QuestionLibraryOverview extends Component {
    componentDidMount() {
    const { getQuestionLibraryFromOverview, loadTemplateLanguages } = this.props;
    //We are triggering 'ducks' function, that will make a rest call and fetch data from the server.

    loadTemplateLanguages();
    getQuestionLibraryFromOverview();
    this.props.loadAllData();
  }

  componentWillUnmount() {
    this.props.changeProperty(ACTION_FIELD, undefined);
    this.props.changeProperty(RESULT, undefined);
  }

  render() {
    const {
      showModalQuestionLibrarySettings,
      questionName,
      questionId,
      questionIdValid,
      previewImageData,
      editQuestionFromLibrary,
      templateLanguages,
      surveyLanguageForQuestionLibrary,
      changeProperty,
      selectedActionField,
      selectedResult,
      questionLibrary,
      questionActionField,
      questionResult
    } = this.props;

    const filteredQuestions = questionLibrary.filter((question) => {
      let match = true;
      if (selectedActionField && question.actionField) {
        match = question.actionField.id === selectedActionField.id;
      }

      if (match && selectedResult && question.result) {
        match = question.result.id === selectedResult.id;
      }

      return match;
    });

    return (
      <StandardView id="questionLibrary" titleKey="question.library">
        <QuestionStructureSelectContainer
          id={"questionStructureFilter"}
          onActionFieldChange={(af) => {
            changeProperty(ACTION_FIELD, af);
          }}
          onResultChange={(result) => {
            changeProperty(RESULT, result);
          }}
          selectedActionFieldId={selectedActionField ? selectedActionField.id : undefined}
          selectedResultId={selectedResult ? selectedResult.id : undefined}
        />
        <QuestionLibraryOverviewTable
          questionLibrary={filteredQuestions}
          showSettingsModalQuestionToLibrary={this.props.showSettingsModalQuestionToLibrary}
          removeQuestionFromLibrary={this.props.removeQuestionFromLibrary}
          sortColumn={this.props.sortColumn}
          showDialog={this.props.showDialog}
          sortTableOrder={this.props.sortTableOrder}
          colSubtype={this.props.colSubtype}
          sortTableBy={this.props.sortTableBy}
          locale={this.props.locale}
        />
        {showModalQuestionLibrarySettings && (
          <QuestionLibraryModal
            showModalQuestionLibrarySettings={showModalQuestionLibrarySettings}
            addQuestionToLibrary={editQuestionFromLibrary}
            questionName={questionName}
            questionId={questionId}
            questionIdValid={questionIdValid}
            previewImageData={previewImageData}
            surveyLanguageForQuestionLibrary={surveyLanguageForQuestionLibrary}
            templateLanguages={templateLanguages}
            changeProperty={changeProperty}
            target="questionLibrary"
            questionActionField={questionActionField}
            questionResult={questionResult}
          />
        )}
      </StandardView>
    );
  }
}

QuestionLibraryOverview.propTypes = {
  showModalQuestionLibrarySettings: PropTypes.bool,
  getQuestionLibrary: PropTypes.func,
  changeProperty: PropTypes.func,
  editQuestionFromLibrary: PropTypes.func,
  loadTemplateLanguages: PropTypes.func,
  questionName: PropTypes.string,
  questionId: PropTypes.string,
  questionIdValid: PropTypes.bool,
  previewImageData: PropTypes.string,
  selectedActionField: PropTypes.object,
  selectedResult: PropTypes.object,
  templateLanguages: PropTypes.array,
  surveyLanguageForQuestionLibrary: PropTypes.object,
  loadAllData: PropTypes.func,
  locale: PropTypes.string.isRequired
};

export default QuestionLibraryOverview;
